﻿export class AmbiguousWorkItem {
}